/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { RotateSquareRightIcon16Light } from './RotateSquareRightIcon16Light';
import { RotateSquareRightIcon16Regular } from './RotateSquareRightIcon16Regular';
import { RotateSquareRightIcon16Solid } from './RotateSquareRightIcon16Solid';
import { RotateSquareRightIcon20Light } from './RotateSquareRightIcon20Light';
import { RotateSquareRightIcon20Regular } from './RotateSquareRightIcon20Regular';
import { RotateSquareRightIcon20Solid } from './RotateSquareRightIcon20Solid';
import { RotateSquareRightIcon24Regular } from './RotateSquareRightIcon24Regular';
import { RotateSquareRightIcon24Solid } from './RotateSquareRightIcon24Solid';
import { RotateSquareRightIcon32Regular } from './RotateSquareRightIcon32Regular';
import { RotateSquareRightIcon64Regular } from './RotateSquareRightIcon64Regular';
var sizes = {
    16: {
        light: RotateSquareRightIcon16Light,
        regular: RotateSquareRightIcon16Regular,
        solid: RotateSquareRightIcon16Solid,
    },
    20: {
        light: RotateSquareRightIcon20Light,
        regular: RotateSquareRightIcon20Regular,
        solid: RotateSquareRightIcon20Solid,
    },
    24: {
        regular: RotateSquareRightIcon24Regular,
        solid: RotateSquareRightIcon24Solid,
    },
    32: {
        regular: RotateSquareRightIcon32Regular,
    },
    64: {
        regular: RotateSquareRightIcon64Regular,
    },
};
export var RotateSquareRightIcon = forwardRef('RotateSquareRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
